import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

const Callback: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (auth.activeNavigator) {
      // Handle navigation (e.g., redirect to login page)
      return;
    }

    if (auth.isLoading) {
      return;
    }

    if (auth.error) {
      console.error('OIDC Error:', auth.error);
      // Handle error - redirect to error page or show error message
      return;
    }

    if (auth.isAuthenticated) {
      // Clean up OAuth query params from URL
      const url = new URL(window.location.href);
      url.searchParams.delete('state');
      url.searchParams.delete('session_state');
      url.searchParams.delete('code');
      url.searchParams.delete('iss');

      // Use replaceState to clean URL without causing a page reload
      window.history.replaceState({}, '', url.pathname);

      // Navigate to home using React Router
      navigate('/', { replace: true });
    }
  }, [auth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default Callback;
